import { queryKey } from '../constants/queryClientKey';
import { createAttachment } from '../apis/attachment.api';
import { getKeyImages } from '../apis/uploadAttachmentFile';
import {
  useMutation,
  useQuery,
  useQueryClient,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

export function useGetKeyImages(id, config?: UseQueryOptions) {
  return useQuery(['getKeyImages', id], () => getKeyImages(id), {
    ...config,
    onSuccess: (data) => {
      config?.onSuccess && config?.onSuccess(data.data);
    },
  }) as UseQueryResult<Awaited<ReturnType<typeof getKeyImages>>>;
}

export function useCreateAttachment() {
  const queryClient = useQueryClient();

  return useMutation(
    async (params: Parameters<typeof createAttachment>[0]) => createAttachment(params),
    {
      onSuccess: () => {
        queryClient.invalidateQueries([queryKey.create_attachment]);
      },
      onError: (err) => {
        console.error('useCreateAttachment', err);
      },
    }
  );
}
